/**
 * @fileoverview DELETE handler for the "/apps/business/account_fields" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsLegacyCatalogAccountFieldsCacheKeys } from "./constants";
import type { DeleteLegacyCatalogAccountFieldsProps } from "./types";

export const deleteLegacyCatalogAccountFields = reactQueryMutationAdapter(
  appsLegacyCatalogAccountFieldsCacheKeys,
  (props: DeleteLegacyCatalogAccountFieldsProps): Promise<void> => {
    return fetch("/apps/business/account_fields", "DELETE", props, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
